import { ReportDateRangeType } from './date-range-type';
import { TicketReportingFilterDetail } from './ticket-reporting';

export const REPORT_DETAIL_LOCKED_FILTER_KEYS = [
  'date',
  'channel_ids',
  'flow_id',
  'unit_ids',
  'tags',
  'customer_schema_tag_ids',
] as const;

export type ReportMainFilterLockKey = (typeof REPORT_DETAIL_LOCKED_FILTER_KEYS)[number];
export type ReportDetailLockedFilterKey = ReportMainFilterLockKey;

export type ReportDetailLockedFilterMap = Record<ReportMainFilterLockKey, boolean>;

export const DEFAULT_REPORT_DETAIL_LOCKED_FILTERS: ReportDetailLockedFilterMap = {
  date: false,
  channel_ids: false,
  flow_id: false,
  unit_ids: false,
  tags: false,
  customer_schema_tag_ids: false,
};

export type ReportDetailFilterOptions = Partial<{
  from_date?: string;
  to_date?: string;
  date_range?: ReportDateRangeType | null;
  channel_types: Array<string>;
  flow_id: Array<string>;
  channel_ids: Array<string>;
  tag_groups: Array<string>;
  tags: Array<string>;
  unit_ids: Array<string>;
  tag_group_ids: Array<string>;
  customer_schema_ids: Array<string>;
  customer_schema_tag_ids: Array<string>;
  locked_filters: Array<ReportMainFilterLockKey>;
}> &
  TicketReportingFilterDetail;
